import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";

export class PresentInfoScene extends Phaser.Scene {

    public static currentInstance: PresentInfoScene; 
   
    constructor() {

        super("PresentInfoScene");
        
        PresentInfoScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const background = this.add.graphics();
        background.fillStyle(0xFF0000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        const title = this.add.text(GameConstants.GAME_WIDTH / 2, 140, "ПОДАРКИ", { fontFamily: "FuturaPTBold", fontSize: "62px", color: "#FFC24B"});
        title.setOrigin(.5);
        title.scaleY = GameVars.scaleY;

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT /2 -  200 * GameVars.scaleY);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        if (GameVars.aspectRatio < 1.65) {
            scaledItemsContainer.scaleX = .85;
            scaledItemsContainer.scaleY = .85 * GameVars.scaleY;
        } else {
            scaledItemsContainer.scaleX = 1;
            scaledItemsContainer.scaleY = GameVars.scaleY;
        }

        const prizeData = GameVars.prizeResults.prizes[GameVars.selectedPresent];
        
        let itemImg: Phaser.GameObjects.Image;

        if (prizeData.image) {

            itemImg= new Phaser.GameObjects.Image(this, 0, -80, "prize-image-" + prizeData.id);

            const scale = 650 / itemImg.width;
    
            itemImg.setScale(scale);

        } else {
            itemImg= new Phaser.GameObjects.Image(this, 0, -80, "texture_atlas_1", "box_big");
        }

        scaledItemsContainer.add(itemImg);

        const description = prizeData.description;

        let fontSize: string;

        if (description.length < 40) {
            fontSize = "72px";
        } else if (description.length < 60) {
            fontSize = "68px";
        } else if(description.length < 100) {
            fontSize = "66px";
        } else {
            fontSize = "62px";
        }

        const descriptionLabel = new Phaser.GameObjects.Text(this, 0, 500, description, 
            { 
                fontFamily: "FuturaPTBook", 
                fontSize: fontSize, 
                color: "#FFE0B1", 
                align: "center",
                wordWrap: {width: 960, useAdvancedWrap: true }
            });
        descriptionLabel.setOrigin(.5)
        scaledItemsContainer.add(descriptionLabel);

        const backButton = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 180 * GameVars.scaleY, "texture_atlas_1", "btn_back");
        backButton.setInteractive();
        backButton.scaleY = GameVars.scaleY;
        backButton.on("pointerover", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerout", () => {
            backButton.setScale(1, GameVars.scaleY);
        }, this);

        backButton.on("pointerdown", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerup", () => {
            backButton.setScale(1);
            GameManager.enterPrizesScene();
            this.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);

        this.add.existing(backButton);

        this.cameras.main.fadeIn(200, 194, 0, 0)
    }
}
